var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ProjectCategory } from '@/api-gateway';
import TableComponent from '@/components/table-component/TableComponent.vue';
import TableProjectList from '@/components/table-project-list/TableProjectList.vue';
import { getReadableProjectCategory, formatDate } from '@/utils/string';
var ProjectList = /** @class */ (function (_super) {
    __extends(ProjectList, _super);
    function ProjectList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pagination = { offset: 0 };
        return _this;
    }
    Object.defineProperty(ProjectList.prototype, "projectList", {
        get: function () {
            var _this = this;
            return this.projects.map(function (project) {
                var _a;
                var category = project.category;
                if (project.category === ProjectCategory.REBRANDING) {
                    category = 'Rebrand+/Refresh';
                }
                else if (project.category === ProjectCategory.PLANNINGANDMALL) {
                    category = 'Planning/Mall';
                }
                return __assign(__assign({}, project), { col1: project.name + " " + project.region + " " + ((_a = project.subFormat) === null || _a === void 0 ? void 0 : _a.name) + " " + (project.type && project.type.name) + " " + project.format.name + " " + category, status: project.status, approveDate: formatDate(project.targetApproveDate), handOverDate: formatDate(project.targetHandOverDate), openDate: formatDate(project.targetOpenDate), projectStatusColor: _this.getStatusColor(project.status), presentSiteDate: formatDate(project.targetPresentSiteDate), firstCIADate: formatDate(project.targetFirstCIADate), tpmDate: formatDate(project.targetTPMDate), formatName: _this.setFormatName(project) });
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectList.prototype, "columnDefs", {
        get: function () {
            var _this = this;
            var cols = [
                {
                    headerName: '',
                    field: 'order',
                    maxWidth: 30,
                    resizable: false,
                    suppressMovable: true,
                    cellRenderer: function (params) {
                        return "<div class=\"custom-row-full\"><span>" + (params.rowIndex + _this.pagination.offset + 1) + "</span></div>";
                    }
                },
                {
                    headerName: 'Select all records',
                    field: 'col1',
                    resizable: false,
                    suppressMovable: true,
                    flex: 2,
                    cellRenderer: function (params) {
                        var format = params.data.format.name;
                        if (params.data.category === ProjectCategory.REBRANDING ||
                            params.data.category === ProjectCategory.PLANNINGANDMALL) {
                            format = getReadableProjectCategory(params.data.category);
                        }
                        return "<div class=\"custom-row\">\n                      <a href=\"/projects/" + params.data.id + "/view/info\" class=\"row-title truncate ...?\">\n                        " + params.data.name + "\n                      </a>\n                      </br>\n                      <span class=\"row-text\">\n                        " + format + "\n                      </span>\n                    </div>";
                    }
                }
            ];
            if (this.showAllDateInfo) {
                cols = __spreadArrays(cols, [
                    {
                        headerName: '',
                        resizable: false,
                        field: 'presentSiteDate',
                        suppressMovable: true,
                        flex: 1,
                        cellRenderer: function (params) {
                            return "<div class=\"row-date\">\n                      <span class=\"row-text\">\n                        Target Present Site:\n                      </span>\n                      </br>\n                      <span class=\"row-text row-date-medium-bold \">\n                        " + params.data.presentSiteDate + "\n                      </span>\n                    </div>";
                        }
                    },
                    {
                        headerName: '',
                        resizable: false,
                        field: 'firstCIADate',
                        suppressMovable: true,
                        flex: 1,
                        cellRenderer: function (params) {
                            return "<div class=\"row-date\">\n                        <span class=\"row-text\">\n                          Target 1st CIA:\n                        </span>\n                        </br>\n                        <span class=\"row-text row-date-medium-bold \">\n                          " + params.data.firstCIADate + "\n                        </span>\n                      </div>";
                        }
                    },
                    {
                        headerName: '',
                        resizable: false,
                        field: 'tpmDate',
                        suppressMovable: true,
                        flex: 1,
                        cellRenderer: function (params) {
                            return "<div class=\"row-date\">\n                        <span class=\"row-text\">\n                          Target TPM/AMD:\n                        </span>\n                        </br>\n                        <span class=\"row-text row-date-medium-bold \">\n                          " + params.data.tpmDate + "\n                        </span>\n                      </div>";
                        }
                    }
                ]);
            }
            cols = __spreadArrays(cols, [
                {
                    headerName: '',
                    resizable: false,
                    field: 'approveDate',
                    suppressMovable: true,
                    flex: 1,
                    cellRenderer: function (params) {
                        return "<div class=\"row-date\">\n                      <span class=\"row-text\">\n                        Target Approval:\n                      </span>\n                      </br>\n                      <span class=\"row-text row-date-medium-bold \">\n                        " + params.data.approveDate + "\n                      </span>\n                    </div>";
                    }
                },
                {
                    headerName: '',
                    resizable: false,
                    field: 'handOverDate',
                    suppressMovable: true,
                    flex: 1,
                    cellRenderer: function (params) {
                        return "<div class=\"row-date\">\n                      <span class=\"row-text\">\n                        Target Site H/O:\n                      </span>\n                      </br>\n                      <span class=\"row-text row-date-medium-bold \">\n                        " + params.data.handOverDate + "\n                      </span>\n                    </div>";
                    }
                },
                {
                    headerName: '',
                    resizable: false,
                    field: 'openDate',
                    suppressMovable: true,
                    flex: 1,
                    cellRenderer: function (params) {
                        return "<div class=\"row-date\">\n                      <span class=\"row-text\">\n                        Target GO:\n                      </span>\n                      </br>\n                      <span class=\"row-text row-date-medium-bold \">\n                        " + params.data.openDate + "\n                      </span>\n                    </div>";
                    }
                }
            ]);
            cols.push({
                headerName: '',
                field: 'status',
                resizable: false,
                suppressMovable: true,
                flex: 1,
                cellRenderer: function (params) {
                    return params.data.status
                        ? "<div class=\"custom-row-full\">\n                    <div class='row-status " + params.data.projectStatusColor + "'>\n                      <p class=\"status-text\">" + params.data.status + "</p>\n                    </div>\n                  </div>"
                        : '';
                }
            });
            return cols;
        },
        enumerable: false,
        configurable: true
    });
    ProjectList.prototype.getStatusColor = function (status) {
        switch (status === null || status === void 0 ? void 0 : status.toLowerCase()) {
            case 'nwt present site':
                return 'status-color-1';
            case 'nwt present scheme':
                return 'status-color-2';
            case 'nwt cia':
                return 'status-color-10';
            case 'tpm':
                return 'status-color-4';
            case 'ic':
                return 'status-color-5';
            case 'cprd excom':
                return 'status-color-6';
            case 'pre construction':
                return 'status-color-7';
            case 'construction':
                return 'status-color-8';
            case 'store opening':
                return 'status-color-9';
            case 'pause':
            case 'onhold':
                return 'status-pause';
            case 'strategy proposal':
                return 'status-color-10';
            case 'store walk':
                return 'status-color-3';
            case 'layout development':
                return 'status-color-4';
            case 'waiting for approval':
                return 'status-color-5';
            default:
                return this.getOtherColor(status === null || status === void 0 ? void 0 : status.toLowerCase());
        }
    };
    ProjectList.prototype.getOtherColor = function (status) {
        var st = status.toLowerCase();
        var splitStatus = st.split(' ')[0];
        var class_color = null;
        switch (splitStatus) {
            case 'pre':
                class_color = 'status-color-11';
                break;
            case 'construction':
                class_color = 'status-color-12';
                break;
            case 'opening':
            case 'completed':
            case 'store':
            case 'handover':
                if (splitStatus === 'store') {
                    class_color =
                        st === 'store opening' ? 'status-color-13' : 'status-color-10';
                }
                else {
                    class_color = 'status-color-13';
                }
                break;
            case 'ic':
                class_color = 'status-color-14';
                break;
            case 'tpm':
                class_color = 'status-color-15';
                break;
            case 'nwt':
                class_color = 'status-color-10';
                break;
            case 'layout':
                class_color = 'status-color-17';
                break;
            case 'cprd':
                class_color = 'status-color-18';
                break;
            case 'strategy':
                class_color = 'status-color-19';
                break;
            case 'waiting':
                class_color = 'status-color-20';
                break;
            case 'project':
                class_color = 'status-color-21';
                break;
            case 'tor':
                class_color = 'status-color-22';
                break;
            case 'award':
                class_color = 'status-color-23';
                break;
            case 'fm':
                class_color = 'status-color-24';
                break;
            case 'kick':
                class_color = 'status-color-25';
                break;
            default:
                class_color = 'status-color-10';
                break;
        }
        return class_color;
    };
    ProjectList.prototype.onPaginationChanged = function (val) {
        this.pagination = val;
        this.$emit('pagination-changed', val);
    };
    ProjectList.prototype.setFormatName = function (data) {
        var format = data.format.name;
        if (data.category === ProjectCategory.REBRANDING ||
            data.category === ProjectCategory.PLANNINGANDMALL) {
            format = getReadableProjectCategory(data.category);
        }
        return format;
    };
    ProjectList.prototype.exportProjects = function () {
        this.$emit('export');
    };
    ProjectList.prototype.fetchProject = function () {
        this.$emit('fetch');
    };
    ProjectList.prototype.sortData = function (val) {
        this.$emit('sort', val);
    };
    ProjectList.prototype.filterStatus = function (val) {
        this.$emit('filter', val);
    };
    __decorate([
        Prop({
            required: true,
            type: Array,
            default: function () { return []; }
        })
    ], ProjectList.prototype, "projects", void 0);
    __decorate([
        Prop({
            type: Array,
            default: function () { return []; }
        })
    ], ProjectList.prototype, "value", void 0);
    __decorate([
        Prop({
            type: Function
        })
    ], ProjectList.prototype, "onRowClicked", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], ProjectList.prototype, "isShowPaginate", void 0);
    __decorate([
        Prop({
            type: Number
        })
    ], ProjectList.prototype, "defaultPaginationSize", void 0);
    __decorate([
        Prop({
            type: Array,
            default: function () { return []; }
        })
    ], ProjectList.prototype, "paginationSizes", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], ProjectList.prototype, "isShowCheckBox", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], ProjectList.prototype, "isShowHeaderTable", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], ProjectList.prototype, "showAllDateInfo", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], ProjectList.prototype, "enableInfiniteScroll", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], ProjectList.prototype, "isProject", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], ProjectList.prototype, "isEdit", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], ProjectList.prototype, "isExport", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], ProjectList.prototype, "isImport", void 0);
    __decorate([
        Prop({
            type: Number,
            default: 0
        })
    ], ProjectList.prototype, "totalRows", void 0);
    ProjectList = __decorate([
        Component({
            components: {
                TableComponent: TableComponent,
                TableProjectList: TableProjectList
            }
        })
    ], ProjectList);
    return ProjectList;
}(Vue));
export default ProjectList;
